// ** MUI Imports
import { Theme } from '@material-ui/core';

const list = (_theme: Theme) => ({
  MuiList: {
    root: {
      borderRadius: 12
    }
  }
});

export default list;
